import Alpine from '@theme/alpine';
import collectionStore from '@theme/alpine-collection-store';
import collectionComponent from '@theme/alpine-collection-component';
import searchComponent from '@theme/alpine-search-component';
import sortingComponent from '@theme/alpine-sorting-component';
import filterComponent from '@theme/alpine-filter-component';
import filterListComponent from '@theme/alpine-filter-list-component';
import filterSwitchComponent from '@theme/alpine-filter-switch-component';
import filterRemoveComponent from '@theme/alpine-filter-remove-component';
import paginationComponent from '@theme/alpine-pagination-component';


// Custom data-x- Alpine directives prefix for better HTML validity
Alpine.prefix('data-x-');

Alpine.store('collectionStore', collectionStore);

Alpine.data('collectionComponent', collectionComponent);
Alpine.data('searchComponent', searchComponent);
Alpine.data('sortingComponent', sortingComponent);
Alpine.data('filterComponent', filterComponent);	
Alpine.data('filterListComponent', filterListComponent);
Alpine.data('filterSwitchComponent', filterSwitchComponent);
Alpine.data('filterRemoveComponent', filterRemoveComponent);
Alpine.data('paginationComponent', paginationComponent);

Alpine.start();